import { Box, BoxProps } from '@razorpay/blade/components';
import styled from 'styled-components';

export const FormWrapper = styled.form`
  display: grid;
  grid-template-rows: 1fr auto;
  height: 100%;
`;

export const StepContentContainer = styled.div`
  display: flex;
  width: 100%;
  padding: ${({ theme }) => theme.spacing[8]}px;
`;

export const StepContentWrapper = ({ children, ...boxProps }: BoxProps) => (
  <StepContentContainer>
    <Box maxWidth="700px" width={{ base: '100%', m: '700px' }} marginX="auto" {...boxProps}>
      {children}
    </Box>
  </StepContentContainer>
);